module.exports = __webpack_public_path__ + "img/error.defc0d5c.gif";